import * as React from 'react';
import styled, { css } from 'styled-components';
import reviewsIcon from '../../assets/man-proud.png';
import rankIcon from '../../assets/stars-rank.svg';

import {
  // StyledLink as SLink,
  OnlineButton,
  Rank,
  StarSize,
  TitleV2 as Title,
} from '@sunbit-dev/web-ui-lib';

const SReviewsContainer = styled.div(
  () => `
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 50px;
    max-width: 910px;
    margin: auto;
    align-items: center;
    box-sizing: border-box;
`
);

const SReview = styled.div(
  () => `
    font-family: Poppins;
    font-size: 12px;
    line-height: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 30px;
    & h6 {
        font-family: Poppins;
        font-size: 12px;
        display: flex;
        font-weight: 300;
    }
  `
);

const SReviewTitle = styled.div(
  () => `
    font-family: Popping;
    font-size: 12px;
    display: flex;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #8B939E;
    ${SIcon} {
        height: 10px;
        width: auto;
        padding: 5px;
    }
    & h5 {
        font-family: Poppins;
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
        display: flex;
        align-items: center;
        color: #000000;
    }
  `
);

const SBox = styled.div(
  () => `
    width: 100%;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 8px 28px -6px rgba(24, 39, 75, 0.12), 0px 18px 88px -4px rgba(24, 39, 75, 0.14);
    border-radius: 8px;
    font-family: Poppins;
    font-size: 14px;
    line-height: 21px;
    color: #4A5568;
    padding: 20px;
`
);

const STitle = styled(Title as any)(
  ({ theme }) => `
    padding: 10px;
    text-align: left;
    @media only screen and ${theme.device.max.laptopS} {
      flex-direction: column;
      text-align: center;
    }
`
);

const SIcon = styled.img(
  ({ theme }) => `
    width: 50%;
    max-width: 440px;
    height: auto;
    margin: 30px 0;
    @media only screen and ${theme.device.max.laptopS} {
      width: 220px;
    }
`
);

const SButton = styled(OnlineButton)(
  ({ theme }) => `
        font-size: ${theme.font.size.smallMedium};
        background: ${theme.colors.primaryBright};
        margin-top: 60px;
        min-width: 240px;
  `
);

const SReviewsHeader = styled.div(
  ({ theme }) => `
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 40px;
      @media only screen and ${theme.device.max.laptopS} {
        flex-direction: column;
      }
  `
);

const STitleGroup = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
    max-width: 440px;
    margin-right: 50px;
    @media only screen and ${theme.device.max.laptopS} {
      align-items: center;
      margin-right: 0;
      width: 100%;
    }
  `
);

export default function Reviews(props) {
  return (
    <SReviewsContainer>
      <SReviewsHeader>
        <SIcon src={reviewsIcon} />
        <STitleGroup>
          <STitle>Proudly serving our customers</STitle>
          <Rank title="133 Google reviews 4.6" rank={4.6} size={StarSize.Large} />
        </STitleGroup>
      </SReviewsHeader>
      <SReview>
        <SBox>
          <SReviewTitle>
            <h5>Jeff Copeland</h5>
          </SReviewTitle>
          <SReviewTitle>
            <SIcon src={rankIcon} />
            <p>2 weeks ago</p>
          </SReviewTitle>
          <p>
            “Very rarely do I encounter a company, especially a company that lends money to people, that from beginning to end is so awesome. I have a credit
            card with this company and before that they helped me finance a new set of tires...” {/*<SLink>see more</SLink>*/}
          </p>
        </SBox>
      </SReview>

      <SButton dataAt="get-started-reviews" submit={props.submit} buttonText="Get started!"></SButton>
    </SReviewsContainer>
  );
}
